// extracted by mini-css-extract-plugin
module.exports = {"VimeoPlayer":"VimeoPlayer_VimeoPlayer__IvOPI","mutedAndLooping":"VimeoPlayer_mutedAndLooping__FY_AM","innerPlayer":"VimeoPlayer_innerPlayer__NeUIm"};